<template>
  <authorization permissionKey="configuration_attendance_place" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Ilhas de atendimento
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary">
            <v-tab v-for="attendancePlace in attendancePlaces" :key="attendancePlace.id">
              {{ attendancePlace.name }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="attendancePlace in attendancePlaces" :key="attendancePlace.id">
              <v-card>
                <v-container>
                  <v-row dense v-for="children in attendancePlace.children" :key="children.id">
                    <v-col>
                      <EmployeeAttendancePlaceList
                        :attendancePlace="children"
                        :showList="children.id === showAttendancePlaceId"
                        :toggleAttendancePlace="toggleAttendancePlace"
                        :employees="employees"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import EmployeeAttendancePlaceList from "@/components/config/attendance_place/employee_attendance_place/list.vue";

  export default {
    name: "AttendancePlaceConfig",
    components: {
      EmployeeAttendancePlaceList,
    },
    data() {
      return {
        showAttendancePlaceId: null,
        tab: null,
      };
    },
    apollo: {
      attendancePlaces: {
        query: require("@/graphql/attendance_place/attendance_places.gql"),
        variables() {
          return {
            attendancePlaceCategory: "nursing_of_clinic",
          };
        },
      },
      employees: {
        query: require("@/graphql/employees/employees.gql"),
        variables() {
          return {
            employeeType: "doctor",
          };
        },
      },
    },
    methods: {
      toggleAttendancePlace(attendancePlace) {
        if (this.showAttendancePlaceId === attendancePlace.id) {
          return (this.showAttendancePlaceId = null);
        }

        this.showAttendancePlaceId = attendancePlace.id;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
